import React, { Component } from 'react';
import JsBarcode from 'jsbarcode';

class Viivakoodi extends Component {
  el;
  str;

  componentDidMount() {
    this.generate(this.props);
  }

  // Changes the barcode depending on selected bank
  shouldComponentUpdate(nextProps, prevState) {
    this.generate(nextProps);
    return true;
  }

  generate(props) {
    // strip country code
    const iban = props.iban.slice(2);

    // leftpadded cents
    const sum = ("" + Math.round(props.summa * 100)).padStart(8, '0');

    // strip 'RF'
    const viite = props.viite.slice(2);

    // zerofill
    const fillLength = 23 - viite.length;
    const fill = '0'.repeat(fillLength);
    const ref = viite.slice(0, 2) + fill + viite.slice(2);

    const a = props.erapvm;

    const erapvm = ("" + a.getFullYear()).slice(2) + (a.getMonth() + 1 + "").padStart(2, '0') + ("" + a.getDate()).padStart(2, '0');

    this.str = '5' + iban + sum + ref + erapvm;

    new JsBarcode(this.el, this.str, {
      format: 'CODE128',
      background: 'transparent',
      displayValue: false,
      margin: 0
    });

    this.forceUpdate();
  }

  render() {
    return (
      <div className="text-center">
        <canvas
          ref={el => this.el = el}
          className="full-width"
        />
        <span style={{ wordBreak: 'break-word', fontFamily: 'monospace', fontSize: 16 }}>{this.str}</span>
      </div>
    );
  }
}

export default Viivakoodi;
